import React from 'react';
import styled from 'styled-components';
import IconTick from '@images/IconTick';
import { Body } from '../Typography';

interface Props {
  data: string[];
  columns?: number;
  Icon?: React.ElementType;
}

const TicksList: React.FC<Props> = ({ data, columns = 1, Icon = IconTick }) => (
  <Container $columns={columns} className="ticks-list-container">
    {data.map((item, index) => (
      <ListItemWrap key={index} className="ticks-list-item">
        {Icon && <Icon style={{ alignSelf: 'center' }} />} {/* Ensure Icon is used correctly */}
        <Body>{item}</Body>
      </ListItemWrap>
    ))}
  </Container>
);

export default TicksList;

interface StyleProps {
  $columns: number;
}

const Container = styled.div<StyleProps>`
  display: flex;
  row-gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  div {
    width: ${(props) => 100 / props.$columns}%;
  }
`;

const ListItemWrap = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  svg {
    flex-shrink: 0;
  }
`;
